import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.value,
      "title": "快速建立 MPPT串列對應",
      "size": "xl",
      "scrollable": "",
      "ok-title": "寫入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.built
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('input', $event);
      },
      "show": _vm.onShow,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "qb_form"
  }, [_c('label', [_vm._v("INV 台數 "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "200",
      "size": "sm"
    },
    model: {
      value: _vm.invCount,
      callback: function callback($$v) {
        _vm.invCount = _vm._n($$v);
      },
      expression: "invCount"
    }
  })], 1), _c('label', [_vm._v("每台 MPPT 數 "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "20",
      "size": "sm"
    },
    model: {
      value: _vm.mpptCount,
      callback: function callback($$v) {
        _vm.mpptCount = _vm._n($$v);
      },
      expression: "mpptCount"
    }
  })], 1), _c('label', [_vm._v("每個 MPPT 幾串 "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "10",
      "size": "sm"
    },
    model: {
      value: _vm.perMppt,
      callback: function callback($$v) {
        _vm.perMppt = _vm._n($$v);
      },
      expression: "perMppt"
    }
  })], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.build
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  }), _vm._v(" 產生列表 ")])], 1), _vm.existing ? _c('b-alert', {
    staticClass: "py-2 qb_hint",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.siteCode) + " 已經有 " + _vm._s(_vm.existing) + " 列。寫入時"), _c('strong', [_vm._v("已存在的位置會略過、不覆蓋")]), _vm._v("； 要整個重建，先在表格裡把舊的刪掉。 ")]) : _vm._e(), _vm.error ? _c('b-alert', {
    staticClass: "py-2 qb_hint",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.built ? [_c('div', {
    staticClass: "qb_hint mb-2"
  }, [_vm._v(" 點格子切換「有接 ⇄ 空接」；點欄位標頭整欄切換，點 INV 名稱整台切換。 共 " + _vm._s(_vm.rows.length) + " 格，有接 "), _c('strong', [_vm._v(_vm._s(_vm.liveCount))]), _vm._v(" 串、空接 "), _c('strong', [_vm._v(_vm._s(_vm.rows.length - _vm.liveCount))]), _vm._v(" 格。 ")]), _c('div', {
    staticClass: "qb_scroll"
  }, [_c('table', {
    staticClass: "qb_grid"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("INV")]), _vm._l(_vm.built.mpptCount, function (m) {
    return _c('th', {
      key: m,
      attrs: {
        "colspan": _vm.built.perMppt
      }
    }, [_vm._v("MPPT" + _vm._s(m))]);
  })], 2), _c('tr', _vm._l(_vm.slotCount, function (idx) {
    return _c('th', {
      key: idx,
      staticClass: "qb_click",
      attrs: {
        "title": "\u6574\u6B04\u5207\u63DB\uFF1A\u6BCF\u53F0\u7684\u4E32\u5217\u7D22\u5F15 ".concat(idx - 1)
      },
      on: {
        "click": function click($event) {
          return _vm.toggleColumn(idx - 1);
        }
      }
    }, [_vm._v(_vm._s(idx - 1))]);
  }), 0)]), _c('tbody', _vm._l(_vm.built.invCount, function (inv) {
    return _c('tr', {
      key: inv
    }, [_c('th', {
      staticClass: "qb_click",
      attrs: {
        "title": "整台切換"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleInv(inv - 1);
        }
      }
    }, [_vm._v("INV" + _vm._s(inv))]), _vm._l(_vm.slotCount, function (idx) {
      return _c('td', {
        key: idx,
        staticClass: "qb_cell",
        class: {
          qb_dead: _vm.dead["".concat(inv - 1, "/").concat(idx - 1)]
        },
        on: {
          "click": function click($event) {
            return _vm.toggle(inv - 1, idx - 1);
          }
        }
      }, [_vm._v(_vm._s(_vm.dead["".concat(inv - 1, "/").concat(idx - 1)] ? '空接' : _vm.idOf(inv - 1, idx - 1)))]);
    })], 2);
  }), 0)])])] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };